import React from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, ActivityIndicator, ScrollView } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';

export default function ProposalDisplay({
  proposal,
  editableProposal,
  isEditing,
  loading,
  onEdit,
  onSaveEdit,
  onRegenerate,
  onCopy,
  onCopyForContra,
  onToggleAssistant,
  showAssistant,
  contraLoading
}) {
  const { colors, glass } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: 'transparent', borderColor: colors.border, ...glass }]}>
      <View style={[styles.header, { borderBottomColor: colors.border }]}>
        <Text style={[styles.title, { color: colors.text }]}>Your Proposal</Text>
        <TouchableOpacity
          onPress={onToggleAssistant}
          style={[
            styles.assistantToggle,
            { backgroundColor: colors.secondary, borderColor: colors.border },
            showAssistant && [styles.assistantToggleActive, { backgroundColor: colors.accent, borderColor: colors.accent }]
          ]}
        >
          <Text style={[styles.assistantToggleText, { color: showAssistant ? '#fff' : colors.text }]}>
            {showAssistant ? '✓ AI Help' : 'AI Help'}
          </Text>
        </TouchableOpacity>
      </View>

      <ScrollView style={styles.proposalContainer}>
        {isEditing ? (
          <>
            <Text style={[styles.editingLabel, { color: colors.accent }]}>Editing Mode</Text>
            <TextInput
              style={[styles.textArea, { backgroundColor: colors.secondary, borderColor: colors.border, color: colors.text }]}
              value={editableProposal}
              onChangeText={onEdit}
              multiline
              numberOfLines={20}
            />
            <TouchableOpacity style={[styles.saveButton, { backgroundColor: colors.accent }]} onPress={onSaveEdit}>
              <Text style={[styles.saveButtonText, { color: '#fff' }]}>Save Edits</Text>
            </TouchableOpacity>
          </>
        ) : (
          <View style={[styles.proposalCard, { backgroundColor: colors.secondary, borderColor: colors.border }]}>
            <Text style={[styles.proposalText, { color: colors.text }]}>{proposal}</Text>
          </View>
        )}
      </ScrollView>

      <View style={[styles.actions, { borderTopColor: colors.border }]}>
        <TouchableOpacity
          style={[styles.actionButton, { backgroundColor: colors.secondary, borderColor: colors.border, borderWidth: 1 }]}
          onPress={onSaveEdit}
        >
          <Text style={[styles.actionButtonText, { color: colors.text }]}>
            {isEditing ? 'Cancel' : 'Edit'}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.actionButton, { backgroundColor: '#6a5aff' }]}
          onPress={onRegenerate}
          disabled={loading}
        >
          {loading ? (
            <ActivityIndicator size="small" color="#fff" />
          ) : (
            <Text style={[styles.actionButtonText, { color: '#fff' }]}>Regenerate</Text>
          )}
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.actionButton, { backgroundColor: '#4a9eff' }]}
          onPress={onCopy}
        >
          <Text style={[styles.actionButtonText, { color: '#fff' }]}>Copy</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.actionButton, { backgroundColor: '#10b981' }]}
          onPress={onCopyForContra}
          disabled={contraLoading}
        >
          {contraLoading ? (
            <ActivityIndicator size="small" color="#fff" />
          ) : (
            <Text style={[styles.actionButtonText, { color: '#fff' }]}>Copy for Contra</Text>
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
    minHeight: 600,
    maxHeight: 800,
    borderRadius: 12,
    borderWidth: 1,
    overflow: 'hidden',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#333',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1e293b',
  },
  assistantToggle: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    backgroundColor: '#333',
    borderWidth: 1,
    borderColor: '#555',
  },
  assistantToggleActive: {
    backgroundColor: '#4a9eff',
    borderColor: '#4a9eff',
  },
  assistantToggleText: {
    color: '#1e293b',
    fontSize: 12,
    fontWeight: '600',
  },
  proposalContainer: {
    flex: 1,
    padding: 20,
  },
  proposalCard: {
    backgroundColor: '#f8fafc',
    borderRadius: 12,
    padding: 20,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },
  proposalText: {
    color: '#1e293b',
    fontSize: 15,
    lineHeight: 24,
  },
  editingLabel: {
    color: '#4a9eff',
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 10,
  },
  textArea: {
    backgroundColor: '#f8fafc',
    borderRadius: 8,
    padding: 15,
    color: '#1e293b',
    fontSize: 14,
    minHeight: 400,
    textAlignVertical: 'top',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    marginBottom: 15,
  },
  saveButton: {
    backgroundColor: '#4a9eff',
    padding: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  saveButtonText: {
    color: '#1e293b',
    fontSize: 14,
    fontWeight: '600',
  },
  actions: {
    flexDirection: 'row',
    padding: 15,
    gap: 10,
    borderTopWidth: 1,
    borderTopColor: '#333',
  },
  actionButton: {
    flex: 1,
    padding: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  actionButtonText: {
    color: '#1e293b',
    fontSize: 14,
    fontWeight: '600',
  },
});
